import axios from "axios";
import { API_ENDPOINTS } from "../Utils/ApiEndPoints";
import axiosInstance from "../Utils/axiosInstance";
class LeaveProcessService {
  static async getEmployeeDashBoard(formData) {
    try {

      const url = API_ENDPOINTS.getEmployeeDashBoard();
      const token = localStorage.getItem('token');
      const response = await axiosInstance.post(url, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          "Authorization": `Bearer ${token}`
        },
      });
      const resultndData = response.data;
      if (resultndData.result > 0) {

        return { success: true, data: resultndData };
      } else {

        return { success: false, data: resultndData };
      }
    } catch (error) {
      console.error("Error creating ticket:", error);
      return { success: false };
    }
  }

  static async getEmployeeCalender(formData) {
    try {

      const url = API_ENDPOINTS.getEmployeeCalender();
      const token = localStorage.getItem('token');
      const response = await axiosInstance.post(url, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          "Authorization": `Bearer ${token}`
        },
      });
      const resultndData = response.data;
      if (resultndData.result > 0) {

        return { success: true, data: resultndData };
      } else {

        return { success: false, data: resultndData };
      }
    } catch (error) {
      console.error("Error creating ticket:", error);
      return { success: false };
    }
  }

  static async setEmployeeLeave(formData) {
    try {
      debugger;
      const url = API_ENDPOINTS.setEmployeeLeave();
      const token = localStorage.getItem('token');
      const response = await axiosInstance.post(url, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          "Authorization": `Bearer ${token}`
        },
      });
      debugger;
      const resultndData = response.data;
      if (resultndData.message != '' && response.data.statusCode === 200) {

        return { success: true, data: resultndData };
      } else {

        return { success: false, data: resultndData };
      }
    } catch (error) {

      if (error.response && error.response.data) {

        const errorMessage = error.response.data.message || "Unknown error from server";
        //alert(errorMessage);
        console.error("API error message:", errorMessage);
        return { success: false, errorMessage };
      } else {
        return { success: false, errorMessage: "Network or unexpected error occurred." };
      }
    }
  }

  static async getEmployeeLeaveStatus(formData) {
    try {
debugger;
      const url = API_ENDPOINTS.getEmployeeLeaveStatus();
      const token = localStorage.getItem('token');
      const response = await axiosInstance.post(url, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          "Authorization": `Bearer ${token}`
        },
      });
      const resultndData = response.data;
      
      if (resultndData.statusCode === 200) {

        return { success: true, data: resultndData };
      } else {

        return { success: false, data: resultndData };
      }
    } catch (error) {

      if (error.response && error.response.data) {

        const errorMessage = error.response.data.message || "Unknown error from server";
        //alert(errorMessage);
        console.error("API error message:", errorMessage);
        return { success: false, errorMessage };
      } else {
        return { success: false, errorMessage: "Network or unexpected error occurred." };
      }
    }
  }

  static async setLeaveMaster(formData) {
    try {
      debugger;
      const url = API_ENDPOINTS.setLeaveMaster();
      const token = localStorage.getItem('token');
      const response = await axiosInstance.post(url, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          "Authorization": `Bearer ${token}`
        },
      });
      const resultndData = response.data;
      if (resultndData.result > 0) {

        return { success: true, data: resultndData };
      } else {

        return { success: false, data: resultndData };
      }
    } catch (error) {

      if (error.response && error.response.data) {

        const errorMessage = error.response.data.message || "Unknown error from server";
        //alert(errorMessage);
        console.error("API error message:", errorMessage);
        return { success: false, errorMessage };
      } else {
        return { success: false, errorMessage: "Network or unexpected error occurred." };
      }
    }
  }


  static async getEmployeeList(formData) {
    try {

      const url = API_ENDPOINTS.getEmployeeList();
      const token = localStorage.getItem('token');
      const response = await axiosInstance.post(url, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          "Authorization": `Bearer ${token}`
        },
      });
      const resultndData = response.data;
      if (resultndData.result > 0) {

        return { success: true, data: resultndData };
      } else {

        return { success: false, data: resultndData };
      }
    } catch (error) {

      if (error.response && error.response.data) {

        const errorMessage = error.response.data.message || "Unknown error from server";
        //alert(errorMessage);
        console.error("API error message:", errorMessage);
        return { success: false, errorMessage };
      } else {
        return { success: false, errorMessage: "Network or unexpected error occurred." };
      }
    }
  }

 static async getEmployeeAttendanceDetails(formData) {
  try {
    const url = API_ENDPOINTS.getEmployeeAttendanceDetails();
    const token = localStorage.getItem("token");

    const response = await axiosInstance.post(url, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        "Authorization": `Bearer ${token}`
      }
    });

    
    const resultndData = response.data;
    console.log("API Response:", resultndData);

    // No data found
    if (
      resultndData?.message === "No Data Found" ||
      !resultndData?.result ||
      resultndData.result.length === 0
    ) {
      return {
        success: false,
        data: [],
        errorMessage: "No Data Found"
      };
    }

    
    // Success
    if (resultndData?.statusCode === 200) {
      return {
        success: true,
        data: resultndData.result
      };
    }

    return {
      success: false,
      errorMessage: resultndData?.message || "Unknown error"
    };

  } catch (error) {
    console.error("Full Error:", error);

    return {
      success: false,
      data: [],
      errorMessage:
        error.response?.data?.message ||
        error.message ||
        "Network or unexpected error occurred."
    };
  }
}

static async getEmployeeShiftDetails(formData) {
  try {
    const url = API_ENDPOINTS.getEmployeeShiftDetails();
    const token = localStorage.getItem("token");

    const response = await axiosInstance.post(url, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        "Authorization": `Bearer ${token}`
      }
    });
debugger;
    
    const resultndData = response.data;
    console.log("API Response:", resultndData);

    // No data found
    if (
      resultndData?.message === "No Data Found" ||
      !resultndData?.result ||
      resultndData.result.length === 0
    ) {
      return {
        success: false,
        data: [],
        errorMessage: "No Data Found"
      };
    }

    
    // Success
    if (resultndData?.statusCode === 200) {
      return {
        success: true,
        data: resultndData.result
      };
    }

    return {
      success: false,
      errorMessage: resultndData?.message || "Unknown error"
    };

  } catch (error) {
    console.error("Full Error:", error);

    return {
      success: false,
      data: [],
      errorMessage:
        error.response?.data?.message ||
        error.message ||
        "Network or unexpected error occurred."
    };
  }
}

  static async getLeaveList(formData) {
    try {

      const url = API_ENDPOINTS.getLeaveList();
      const token = localStorage.getItem('token');
      const response = await axiosInstance.post(url, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          "Authorization": `Bearer ${token}`
        },
      });
      const resultndData = response.data;
      if (resultndData.result > 0) {

        return { success: true, data: resultndData };
      } else {

        return { success: false, data: resultndData };
      }
    } catch (error) {

      if (error.response && error.response.data) {

        const errorMessage = error.response.data.message || "Unknown error from server";
        //alert(errorMessage);
        console.error("API error message:", errorMessage);
        return { success: false, errorMessage };
      } else {
        return { success: false, errorMessage: "Network or unexpected error occurred." };
      }
    }
  }


  static async setLeaveAR(formData) {
    try {

      const url = API_ENDPOINTS.setLeaveAR();
      const token = localStorage.getItem('token');
      const response = await axiosInstance.post(url, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          "Authorization": `Bearer ${token}`
        },
      });
      const resultndData = response.data;
      if (resultndData.result > 0) {

        return { success: true, data: resultndData };
      } else {

        return { success: false, data: resultndData };
      }
    } catch (error) {

      if (error.response && error.response.data) {

        const errorMessage = error.response.data.message || "Unknown error from server";
        //alert(errorMessage);
        console.error("API error message:", errorMessage);
        return { success: false, errorMessage };
      } else {
        return { success: false, errorMessage: "Network or unexpected error occurred." };
      }
    }
  }

  static async setLeaveOD(formData) {
    try {

      const url = API_ENDPOINTS.setLeaveOD();
      const token = localStorage.getItem('token');
      const response = await axiosInstance.post(url, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          "Authorization": `Bearer ${token}`
        },
      });
      const resultndData = response.data;
      if (resultndData.result > 0) {

        return { success: true, data: resultndData };
      } else {

        return { success: false, data: resultndData };
      }
    } catch (error) {

      if (error.response && error.response.data) {

        const errorMessage = error.response.data.message || "Unknown error from server";
        //alert(errorMessage);
        console.error("API error message:", errorMessage);
        return { success: false, errorMessage };
      } else {
        return { success: false, errorMessage: "Network or unexpected error occurred." };
      }
    }
  }

  static async uploadLeave(formData) {
    try {
      debugger;
      const url = API_ENDPOINTS.setLeaveUpload();
      const token = localStorage.getItem('token');
      const response = await axiosInstance.post(url, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          "Authorization": `Bearer ${token}`
        },
      });
      debugger;
      const resultndData = response.data;
      if (response.data && response.data.result) {

        return { success: true, data: resultndData };
      } else {

        return { success: false, data: resultndData };
      }
    } catch (error) {

      if (error.response && error.response.data) {

        const errorMessage = error.response.data.message || "Unknown error from server";
        //alert(errorMessage);
        console.error("API error message:", errorMessage);
        return { success: false, errorMessage };
      } else {
        return { success: false, errorMessage: "Network or unexpected error occurred." };
      }
    }
  }

  static async setLeaveBalanceUpload(formData) {
    try {
      debugger;
      const url = API_ENDPOINTS.setLeaveBalanceUpload();
      const token = localStorage.getItem('token');
      const response = await axiosInstance.post(url, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          "Authorization": `Bearer ${token}`
        },
      });
      debugger;
      const resultndData = response.data;
      if (response.data && response.data.result) {

        return { success: true, data: resultndData };
      } else {

        return { success: false, data: resultndData };
      }
    } catch (error) {

      if (error.response && error.response.data) {

        const errorMessage = error.response.data.message || "Unknown error from server";
        //alert(errorMessage);
        console.error("API error message:", errorMessage);
        return { success: false, errorMessage };
      } else {
        return { success: false, errorMessage: "Network or unexpected error occurred." };
      }
    }
  }

  static async getEmployeeLeaveBalance(formData) {
    try {

      const url = API_ENDPOINTS.getEmployeeLeaveList();
      const token = localStorage.getItem('token');
      const response = await axiosInstance.post(url, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          "Authorization": `Bearer ${token}`
        },
      });
      const resultndData = response.data;
      if (resultndData.result > 0) {

        return { success: true, data: resultndData };
      } else {

        return { success: false, data: resultndData };
      }
    } catch (error) {

      if (error.response && error.response.data) {

        const errorMessage = error.response.data.message || "Unknown error from server";
        //alert(errorMessage);
        console.error("API error message:", errorMessage);
        return { success: false, errorMessage };
      } else {
        return { success: false, errorMessage: "Network or unexpected error occurred." };
      }
    }
  }

  static async setEmployeeLeaveBalance(formData) {
    try {

      const url = API_ENDPOINTS.setEmployeeLeaveList();
      const token = localStorage.getItem('token');
      const response = await axiosInstance.post(url, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          "Authorization": `Bearer ${token}`
        },
      });
      const resultndData = response.data;
      if (resultndData.result > 0) {

        return { success: true, data: resultndData };
      } else {

        return { success: false, data: resultndData };
      }
    } catch (error) {

      if (error.response && error.response.data) {

        const errorMessage = error.response.data.message || "Unknown error from server";
        //alert(errorMessage);
        console.error("API error message:", errorMessage);
        return { success: false, errorMessage };
      } else {
        return { success: false, errorMessage: "Network or unexpected error occurred." };
      }
    }
  }

}

export default LeaveProcessService